export default {
  PT_ADJUST_EVENT_LOGS: {
    path: '/pt-adjust-event-logs',
    name: 'pt_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/AdjustEventLogs')
  },
  PT_CLAIMS: {
    path: '/pt-claims',
    name: 'pt_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'Claims',
      order: 2
    },
    component: () => import('@pt_views/Claims/ClaimsIndex')
  },
  PT_COHORT_ANALYSIS: {
    path: '/pt-cohort-analysis',
    name: 'pt_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  PT_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'pt_cohort_analysis_export',
    name: 'pt_cohort_analysis_export',
    permission: 'pt_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  PT_EMAILS: {
    path: '/pt-emails',
    name: 'pt_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@pt_views/Emails/EmailsIndex')
  },
  PT_PERFORMANCE: {
    path: '/pt-performance',
    name: 'pt_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Performance/PerformanceIndex')
  },
  PT_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'pt_performance_export',
    name: 'pt_performance_export',
    permission: 'pt_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  PT_REWARDS: {
    path: '/pt-rewards',
    name: 'pt_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Rewards')
  },
  PT_TRANSACTIONS: {
    path: '/pt-transactions',
    name: 'pt_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@pt_views/Transactions/TransactionsIndex')
  },
  PT_LEVELS: {
    path: '/pt-levels',
    name: 'pt_levels',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Level')
  },
  PT_LEADERBOARDS: {
    path: '/pt-leaderboards',
    name: 'pt_leaderboards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Leaderboards/LeaderboardsIndex')
  },
  PT_AFFILIATE_PARTNERS: {
    path: '/pt-affiliate-partners',
    name: 'pt_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  PT_USERS: {
    path: '/pt-users',
    name: 'pt_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Users/UsersIndex')
  },
  PT_USERS_EXPORT: {
    type: 'function',
    path: 'pt_users_export',
    name: 'pt_users_export',
    permission: 'pt_users_export',
    meta: {
      requiresAuth: true
    }
  },
  PT_USERS_DELETE: {
    type: 'function',
    path: 'pt_users_delete',
    name: 'pt_users_delete',
    permission: 'pt_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  PT_USER_DETAILS: {
    path: '/pt-user/:userId',
    name: 'pt_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@pt_views/Users/UserDetails')
  },
  PT_TRIGGERS: {
    path: '/pt-triggers',
    name: 'pt_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Triggers/TriggersIndex')
  },
  PT_LOG_SPEND: {
    path: '/pt-log-spend',
    name: 'pt_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/LogSpend')
  },
  PT_OFFER_WALL_PERFORMANCE: {
    path: '/pt-offerwall-performance',
    name: 'pt_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@pt_views/OfferWallPerformance')
  },
  PT_SETTINGS: {
    path: '/pt-settings',
    name: 'pt_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Settings')
  },
  PT_FRONTEND_SETTINGS: {
    path: '/pt-frontend-settings',
    name: 'pt_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  PT_CAMPAIGN_SETTINGS: {
    path: '/pt-campaign-settings',
    name: 'pt_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'paid-tester' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  PT_TUNE_REJECTION_SETTINGS: {
    path: '/pt-tune-rejection-settings',
    name: 'pt_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'paid-tester' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  PT_TUNE_REJECTIONS: {
    path: '/pt-tune-rejections',
    name: 'pt_tune_rejections',
    meta: { requiresAuth: true },
    props: { project: 'paid-tester' },
    component: () => import('@ps_views/shared/tune-rejections/TuneRejectionsIndex.vue')
  },
  PT_BONUS_CODES: {
    path: '/pt-bonus-codes',
    name: 'pt_bonus_codes',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/BonusCodes/BonusCodesIndex.vue')
  },
  PT_BONUS_CODE_REDEMPTIONS: {
    path: '/pt-bonus-code-redemptions',
    name: 'pt_bonus_code_redemptions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'pt',
      title: 'Bonus Codes',
      order: 4
    },
    component: () => import('@pt_views/BonusCodeRedemptions')
  },
  PT_ADJUST_CONFIG: {
    path: '/pt-adjust-config',
    name: 'pt_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  PT_USER_CREDIT: {
    type: 'function',
    path: 'pt_user_credit',
    name: 'pt_user_credit',
    permission: 'pt_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  PT_DYNAMIC_CAMPAIGNS: {
    path: '/pt-dynamic-campaigns',
    name: 'pt_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns')
  },
  PT_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/pt-dynamic-campaigns/emails',
    name: 'pt_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/pt-dynamic-campaigns/emails/create',
    name: 'pt_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/pt-dynamic-campaigns/emails/edit/:id',
    name: 'pt_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/pt-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'pt_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/pt-dynamic-campaigns/push-notifications',
    name: 'pt_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/pt-dynamic-campaigns/push-notifications/create',
    name: 'pt_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/pt-dynamic-campaigns/push-notifications/edit/:id',
    name: 'pt_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/pt-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'pt_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'paid-tester' },
    component: () => import('@pt_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  PT_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/pt-user-reward-eligibility-logs',
    name: 'pt_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@pt_views/Users/UserRewardEligibilityLogs')
  },
  PT_USER_LEVEL: {
    type: 'function',
    path: 'pt_user_level',
    name: 'pt_user_level',
    permission: 'pt_user_level',
    meta: {
      requiresAuth: true
    }
  },
  PT_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'pt_overwrite_eligible',
    name: 'pt_overwrite_eligible',
    permission: 'pt_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  }
}
